/**
 * Klick-Handler für den Skip-Link „Zum Hauptinhalt springen".
 *
 * Mit `<base href="/de/">` löst `href="#main-content"` gegen die Basis auf, nicht
 * gegen die aktuelle Seite: Auf jeder Unterseite lädt der Link die Startseite,
 * statt zum Inhalt zu springen (#1209). Der Handler setzt den Fokus selbst; das
 * href bleibt als Rückfallebene ohne JavaScript.
 */
export function skipToMainContent(event: Event): void {
  const link = event.currentTarget as HTMLElement;
  const main = link.ownerDocument.getElementById('main-content');
  if (!main) return;
  event.preventDefault();
  main.focus();
}
